import { LanguageService, MediaItem } from '@repo/roche-xx-shared';
import React from 'react';
import { DataSearchView } from '../../search/data-search';
import { RocheNewsImporterListItem } from '../../search/data-search/list-items/news-importer-list-item';
import { fetchSwissMediaSearch, fetchSwissNewsList, fetchSwissNewsTabs } from '../../search/data-search/queries';
import { SearchTrackingType } from '../../search/tracking';
import { Props } from './types';

export const RocheMediaSwitzerland = ({ slot }: Props): JSX.Element => {
  return (
    <DataSearchView<MediaItem>
      slot={slot}
      searchTrackingType={SearchTrackingType.MEDIA_RELEASES}
      tabName='year'
      pageName='page'
      queryName='query'
      fetchTabs={fetchSwissNewsTabs}
      fetchList={fetchSwissNewsList}
      fetchSearch={fetchSwissMediaSearch}
      itemRenderer={(item, index, trackingData) => (
        <RocheNewsImporterListItem
          locale={LanguageService.getActiveLanguage()}
          key={`${item.link}-${index}`}
          item={item}
          trackingData={trackingData}
        />
      )}
    />
  );
};
